import { createClient } from "@supabase/supabase-js";
import { env } from "./env";
import { getActiveTenantId, TENANT_HEADER } from "./tenant-context";

/**
 * Ein Client für die ganze Anwendung. Die Mandanten-Kopfzeile wird bei JEDER Anfrage frisch aus
 * dem Tab-Kontext gesetzt — so wirkt ein Mandantenwechsel sofort, ohne neuen Client.
 */
export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
  global: {
    fetch: (input, init) => {
      const headers = new Headers(init?.headers);
      const tenant = getActiveTenantId();
      if (tenant) headers.set(TENANT_HEADER, tenant);
      return fetch(input, { ...init, headers });
    },
  },
});
